import { toast } from "@diametral/design-system/react";

import { ApiError } from "./api";
import { t } from "./i18n";

/** The message to show for any thrown value: the backend's French `detail` when there is one. */
export function messageOf(error: unknown): string {
  if (error instanceof ApiError) return error.message;
  if (error instanceof Error && error.message) return error.message;
  return t("An unexpected error occurred.");
}

export function notifySuccess(title: string, description?: string): void {
  toast.add({ title, description, type: "success" });
}

export function notifyInfo(title: string, description?: string): void {
  toast.add({ title, description, type: "info" });
}

export function notifyError(error: unknown, title?: string): void {
  toast.add({ title: title ?? t("The action failed"), description: messageOf(error), type: "error", priority: "high", timeout: 8000 });
}
